import { Component, OnInit, Input, Output, EventEmitter, DestroyRef, ChangeDetectorRef } from "@angular/core";
import { inject } from "@angular/core";
import { Constants } from "src/app/shared/utils/constants";
import { EPAProjectRunService } from "./esa-project-run.api.service";
import { UdlOverlapToolContainerService } from "src/app/esa-assessment/udl-overlap-tool/udl-overlap-tool-container.service";
import { Project } from "src/app/shared/models/project";
import { UdlModelService } from "../../udl-model.service";
import { take } from "rxjs";

@Component({
    selector: 'app-esa-project-status',
    templateUrl: 'esa-project-status.component.html',
    styleUrls: ['esa-project-status.component.css']
})
export class EASProjectStatusComponenet implements OnInit {
    public statusName: string = '';
    public badgeStyle: string = '';
    public summaryFileName: string = '';
    public isSummaryDownloading: boolean = false;
    public isSummaryDownloadEnabled: boolean = false;
    public downloadSummaryTooltip: string = '';
    @Input() selectedProject?: Project;
    @Output() summaryDownloadAvailable = new EventEmitter<boolean>();
    @Output() projectStatusUpdated = new EventEmitter<number>();

    private projectRunApiService: EPAProjectRunService = inject(EPAProjectRunService);
    private udlOverlapToolContainerService: UdlOverlapToolContainerService = inject(UdlOverlapToolContainerService);
    private modelService: UdlModelService = inject(UdlModelService);
    private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit(): void {
        this.projectRunApiService.projectStatusUpdatedEvent.subscribe((statusId: number) => {
            this.updateStatusGUI(statusId);
        });

        this.projectRunApiService.getRunStatus();
    }

    public onDownloadSummaryFileClick() {
        this.isSummaryDownloading = true;
        this.udlOverlapToolContainerService.projectFileDownloadedEvent.pipe(take(1)).subscribe((fileName: string) => {
            this.isSummaryDownloading = false;
        });
        this.udlOverlapToolContainerService.projectFileDownloadFailedEvent.pipe(take(1)).subscribe(() => {
            this.isSummaryDownloading = false;
        });
        this.udlOverlapToolContainerService.downloadSummaryFile(this.selectedProject!.projectPk, this.modelService.modelVersion);
    }

    private getStatusById(statusId: number): string | undefined {
        const statusKey = Object.keys(Constants.PROJECT_STATUS_ID).find(
            key => Constants.PROJECT_STATUS_ID[key as keyof typeof Constants.PROJECT_STATUS_ID] === statusId
        ) as keyof typeof Constants.PROJECT_STATUS_ID;

        return statusKey ? Constants.PROJECT_STATUS[statusKey as keyof typeof Constants.PROJECT_STATUS] : undefined;
    }

    private getbadgeStyle(statusId: number): string | undefined {
        const statusKey = Object.keys(Constants.PROJECT_STATUS_ID).find(
            key => Constants.PROJECT_STATUS_ID[key as keyof typeof Constants.PROJECT_STATUS_ID] === statusId
        ) as keyof typeof Constants.PROJECT_STATUS_ID;

        return statusKey ? Constants.BADGE_STYLE[statusKey as keyof typeof Constants.BADGE_STYLE] : undefined;
    }

    private updateStatusGUI(statusId: number) {
        this.statusName = this.getStatusById(statusId) || '';
        this.badgeStyle = this.getbadgeStyle(statusId) || '';
        this.isSummaryDownloadEnabled = statusId === Constants.PROJECT_STATUS_ID.SUCCESSFUL;
        this.downloadSummaryTooltip = statusId === Constants.PROJECT_STATUS_ID.SUCCESSFUL ? "Download Summary Report" : "No report available";
        this.summaryDownloadAvailable.emit(this.isSummaryDownloadEnabled);
        this.projectStatusUpdated.emit(statusId);
        this.changeDetectorRef.detectChanges();
    }
}